import { Button, Form, Input, Drawer, Card, Modal, message, Steps } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "moment/locale/vi"; // Import locale tiếng Việt
import React, { useEffect, useState, useRef } from "react";
import $axios from "../../services/axios";
import axios from "axios";
import _, { forEach } from "lodash";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import polyline from "@mapbox/polyline";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import goongjs from "@goongmaps/goong-js";
import "@goongmaps/goong-js/dist/goong-js.css";
import moment from "moment";
import { EStatusTrip } from "../../helpers/const";

const Map = ({
  setStep,
  setLoading,
  loading,
  dataServices,
  dataPlace,
  setDataServices,
}) => {
  const history = useHistory();
  const [openNote, setOpenNote] = useState(false);
  const [openVoucher, setOpenVoucher] = useState(false);
  const [voucherValue, setVoucherValue] = useState(0);
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherTxt, setVoucherTxt] = useState("");
  const mapRef = useRef(null); // Thêm useRef để lưu trữ instance của map
  const markersRef = useRef([]);
  const dataLegRef = useRef(null);
  const [addPrice, setAddPrice] = useState(0);
  const [noteTxt, setNoteTxt] = useState("");
  const [vouchers, setVouchers] = useState([]);
  const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
  const [statusTrip, setStatusTrip] = useState("");
  const [bookingId, setBookingId] = useState("");

  useEffect(() => {
    setLoading(true);
    getAddPrice();
    getVouchers();
    if (typeof window !== "undefined") {
      // Phòng trường hợp SSR
      const initMap = (coords) => {
        goongjs.accessToken = "6twIVlSlDTMzUHQNmIwhtQ3Kse88gqZN3JwnHhbN";
        const defaultCoords = [105.854444, 21.029449]; // Tọa
        mapRef.current = new goongjs.Map({
          container: "map",
          center: coords ? [coords.longitude, coords.latitude] : defaultCoords,
          zoom: 15,
          style: "https://tiles.goong.io/assets/goong_map_web.json",
          attributionControl: false,
        });

        mapRef.current.on("load", () => {
          // Gọi hàm calculateAndDisplayRoute sau khi map đã load
          calculateAndDisplayRoute();
          setLoading(false);
        });
      };

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            initMap(position.coords);
          },
          (err) => {
            console.error("Lỗi khi lấy vị trí: ", err);
            initMap(); // Fallback location
          }
        );
      } else {
        initMap(); // Fallback location
      }
    }
  }, []);

  useEffect(() => {
    console.log(dataServices, "dataServices");
    console.log(dataPlace, "dataPlace");

    // if (dataServices.services.length > 0) {
    //   setVehicleChoose(dataServices.services[0]);
    // }
  }, [dataServices]);

  const handleCancelTrip = async () => {
    setLoading(true);
    try {
      const res = await $axios.$post("/api/v1/say-car/reject-booking", {
        BookingId: bookingId,
      });
      if (res.status === 200) {
        message.success("Hủy chuyến thành công!");
        setStatusTrip(EStatusTrip.CANCELED);
      } else {
        message.error("Hủy chuyến thất bại!");
      }
    } catch (error) {
      console.log(error.response?.data);
      message.error("Hủy chuyến thất bại!");
    } finally {
      setLoading(false);
    }
  };

  const handleBooking = async () => {
    try {
      setLoading(true);
      const activeDestinations = dataPlace.to.filter(
        (place) => place.show && place.placeId
      );

      const body = {
        VoucherCode: voucherCode || "",
        Amount:
          (dataServices?.totalCustomerPaid || 0) + addPrice - voucherValue,
        AmountOriginal: dataServices?.totalCustomerPaid || 0,
        VatFullName: "",
        VatMst: "",
        VatCompany: "",
        VatEmail: "",
        ContactPhone: userInfo?.phone,
        ContactFullname: userInfo?.fullName,
        Note: noteTxt,
        FromLocation: dataPlace.from.description,
        ToLocations: activeDestinations.map((place) => place.description),
        Destinations: activeDestinations.map(
          (place) => `${place.lat},${place.lng}`
        ),
        Origins: `${dataPlace.from.lat},${dataPlace.from.lng}`,
        Vehicle: "CAR",
        Distances: dataServices.distances,
        Durations: dataServices.durations,
      };
      const resPayment = await $axios.$post(
        "/api/v1/payment/paymentRequired",
        body
      );
      if (resPayment.data.data.orderId) {
        alert(resPayment.data.data.orderId);
        const pollUntilBookingId = async (maxRetries = 500, delay = 1000) => {
          for (let i = 0; i < maxRetries; i++) {
            const resTrip = await $axios.get(
              `/api/v1/transactions/details?orderCode=${resPayment.data.data.orderId}`
            );
            const bookingId = resTrip?.data?.data?.data?.bookingId;
            if (bookingId) {
              setBookingId(bookingId);
              setLoading(false);
              return bookingId;
            }

            await new Promise((resolve) => setTimeout(resolve, delay));
          }
          throw new Error("Không lấy được bookingId sau nhiều lần thử");
        };

        const pollUntilTripStatus = async (
          maxRetries = 500,
          delay = 1000,
          resBookingId
        ) => {
          for (let i = 0; i < maxRetries; i++) {
            const resBooking = await $axios.$get(
              `/api/v1/say-car/find-book-by-id?tripId=${resBookingId}`
            );
            if (
              resBooking.data?.data?.statusBooking === EStatusTrip.IN_PROGRESS
            ) {
              setStatusTrip(EStatusTrip.IN_PROGRESS);
            } else if (
              resBooking.data?.data?.statusBooking === EStatusTrip.ACCEPTED
            ) {
              window.location.href = `/tracking?bookingId=${resBookingId}`;
            } else if (
              resBooking.data?.data?.statusBooking === EStatusTrip.CANCELED ||
              resBooking.data?.data?.statusBooking === EStatusTrip.REJECTED
            ) {
              setStatusTrip(resBooking.data?.data?.statusBooking);
              return true;
            }

            await new Promise((resolve) => setTimeout(resolve, delay));
          }
        };
        const resBookingId = await pollUntilBookingId();
        if (resBookingId) {
          pollUntilTripStatus(500, 1000, resBookingId);
        }
        // console.log(tripDetails, "tripDetails");
        // history.push(`/tracking?orderCode=${resPayment.data.data.orderId}`);
        // console.log(resTrip, "resTrip");
        // history.push(`/tracking?orderCode=TaxiSayCar638889528885436314`);
        // setLoading(true);
        // try {
        //   await $axios.$post(`/api/v1/payment/paymentBankInit`, {
        //     TransactionId: resPayment.data.data.orderId,
        //   });
        //   if (
        //     window.webkit &&
        //     window.webkit.messageHandlers &&
        //     window.webkit.messageHandlers.NativeJavascriptInterface
        //   ) {
        //     // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
        //     window.webkit.messageHandlers.NativeJavascriptInterface.postMessage(
        //       {
        //         orderCode: resPayment.data.data.orderId,
        //       }
        //     );
        //   } else {
        //     console.error(
        //       "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
        //     );
        //   }
        // } catch (error) {
        //   message.error(error.response.data.message);
        // } finally {
        //   setLoading(false);
        // }
      }
    } catch (error) {
      message.error("Đã có lỗi xảy ra! Vui lòng đặt chuyến khác");
    } finally {
      setLoading(false);
    }
  };

  const getVouchers = async () => {
    try {
      const res = await $axios.$post("/api/v1/voucher/getVoucherByOrder", {
        Quantity: 1,
        Total: dataServices.totalCustomerPaid,
      });
      const now = moment();
      const validVouchers = res.data.data.filter((voucher) => {
        const start = moment(voucher.startDate);
        const end = moment(voucher.endDate);
        return now.isBetween(start, end, null, "[]"); // [] để bao gồm cả thời gian bắt đầu và kết thúc
      });
      setVouchers(validVouchers);
    } catch (error) {
    } finally {
    }
  };

  const createCustomMarker = (iconUrl, size) => {
    const el = document.createElement("div");
    el.className = "custom-marker";
    el.style.backgroundImage = `url(${iconUrl})`;
    el.style.width = `${size}px`;
    el.style.height = `${size}px`;
    el.style.backgroundSize = "cover";
    return el;
  };

  const createMarker = (latlng, icon, content, title, size = 20) => {
    // Thêm một marker với icon tùy chỉnh
    // @ts-ignore
    const marker = new goongjs.Marker({
      element: createCustomMarker(icon, size),
    })
      .setLngLat([latlng.lng, latlng.lat]) // Tọa độ (Kinh độ, Vĩ độ)
      .addTo(mapRef.current);

    // @ts-ignore
    const popup = new goongjs.Popup({ offset: 25 }).setHTML(content);

    marker.setPopup(popup);
    popup.addTo(mapRef.current);
    markersRef.current.push(marker);
  };

  const calculateAndDisplayRoute = async () => {
    const activeDestinations = dataPlace.to.filter(
      (place) => place.show && place.placeId
    );

    if (!dataPlace.from?.lat || !dataPlace.from?.lng) return;

    mapRef.current?.setCenter({
      lat: dataPlace.from.lat,
      lng: dataPlace.from.lng,
    });

    let layers = mapRef.current?.getStyle().layers;
    let firstSymbolId;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].type === "symbol") {
        firstSymbolId = layers[i].id;
        break;
      }
    }

    forEach(activeDestinations, async (des, index) => {
      const res = await $axios.$get(
        `https://rsapi.goong.io/Direction?origin=${dataPlace.from.lat},${dataPlace.from.lng}&destination=${des.lat},${des.lng}&vehicle=car&api_key=${process.env.REACT_APP_GOOGNG_API_KEY}`
      );

      if (res.data.routes && res.data.routes.length > 0) {
        const route = res.data.routes[0];
        const geometry_string = route.overview_polyline.points;
        const geoJSON = polyline.toGeoJSON(geometry_string);
        const routeId = `route-${index}`;
        const sourceId = `source-${index}`;

        // Thêm source riêng biệt
        if (mapRef.current.getSource(sourceId)) {
          mapRef.current.getSource(sourceId).setData(geoJSON);
        } else {
          mapRef.current.addSource(sourceId, {
            type: "geojson",
            data: geoJSON,
          });

          mapRef.current.addLayer(
            {
              id: routeId,
              type: "line",
              source: sourceId,
              layout: {
                "line-join": "round",
                "line-cap": "round",
              },
              paint: {
                "line-color": "#1e88e5",
                "line-width": 5,
              },
            },
            firstSymbolId
          );
        }

        const leg = route.legs[0];

        if (index === 0) {
          createMarker(
            leg.start_location,
            "/images/person-wave-hand.png",
            `
            <div style="display: flex;padding: 4px;">
              <p style="font-size: 12px; max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;margin-left: 8px;">${leg.start_address}</p>
            </div>
          `,
            leg.start_address
          );
        }

        createMarker(
          leg.end_location,
          "/images/icon-location.png",
          `
          <div style="display: flex;padding: 4px 2px;">
            <p style="font-size: 12px; max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${leg.end_address}</p>
          </div>
        `,
          leg.end_address,
          50
        );
      }
    });
  };

  const getAddPrice = async () => {
    try {
      const res = await $axios.$get(`/api/v1/payment/getAddPrice`);
      if (res.data.data.data.status === 1) {
        const amount = _.get(res, "data.data.data.amount", 0);
        console.log(amount, "amount");

        setAddPrice(amount);
        return amount;
      }
    } catch (error) {
    } finally {
    }
  };

  const focusCurrentLocation = () => {
    const origin = {
      lat: dataPlace.from?.lat,
      lng: dataPlace.from?.lng,
    };
    mapRef.current.setCenter(origin);
    mapRef.current.setZoom(15);
  };

  const applyVoucher = async (e) => {
    if (e) {
      setLoading(true);
      try {
        const res = await $axios.$post(`/api/v1/voucher/getVoucher`, {
          Quantity: 1,
          Total: dataServices.totalCustomerPaid,
          VoucherCode: e,
        });
        if (res.status === 200) {
          applyVoucherPick(res.data.data);
        }
        setVoucherCode("");
      } finally {
        setLoading(false);
      }
    } else {
      setVoucherTxt(
        `<div class="text-[14px] text-red-600">Mã giảm giá không hợp lệ! Vui lòng thử lại</div>`
      );
      setVoucherValue(0);
      setVoucherCode("");
    }
  };

  const applyVoucherPick = async (voucher) => {
    let amount = voucher.amountVoucher;
    if (voucher.discountType === "PERCENTAGE") {
      const amountDiscount = Math.ceil(
        ((dataServices?.totalCustomerPaid || 0) + addPrice) *
          (voucher.discountValue / 100)
      );
      amount =
        amountDiscount < voucher.maxDiscountValue
          ? amountDiscount
          : voucher.maxDiscountValue;
    }
    console.log(amount, "amount");

    setVoucherValue(_.toNumber(amount));
    setVoucherCode(voucher.code);
    setVoucherTxt(
      `<div class="text-[14px] ">Áp dụng mã giảm giá thành công! <span class="text-green-600 text-[16px]">
  ${amount.toLocaleString("vi-VN")} đ</span></div>`
    );
    message.success("Áp dụng mã giảm giá thành công!");
    setOpenVoucher(false);
  };

  return (
    <div className="relative flex flex-col h-[100vh] bg-white">
      <div id="map" className="flex-1 max-h-[100%]"></div>
      {/* <div class="marker-center">
      <img src="/images/mark.svg" alt="icon" class="w-4" />
    </div> */}
      <div className="flex flex-col bg-white relative py-4">
        <div className="flex justify-between absolute top-[-40px] w-full px-4">
          <div className="flex gap-3">
            <Button color="primary" variant="outlined">
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="text-primary"
                onClick={() => {
                  window.location.href = "/booking-driver";
                }}
              />
            </Button>
          </div>
          {/* <Button
            color="primary"
            variant="outlined"
            onClick={() => focusCurrentLocation()}
          >
            <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1">
              <defs></defs>
              <g
                id="Home-2"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g id="1-Home" transform="translate(-259.000000, -279.000000)">
                  <g
                    id="ic_current"
                    transform="translate(259.000000, 279.000000)"
                  >
                    <circle
                      id="Oval"
                      stroke="currentColor"
                      stroke-width="2"
                      fill="#FFFFFF"
                      cx="8.5"
                      cy="8.5"
                      r="7.5"
                    ></circle>
                    <circle
                      id="Oval"
                      fill="currentColor"
                      cx="8.5"
                      cy="8.5"
                      r="4.25"
                    ></circle>
                  </g>
                </g>
              </g>
            </svg>
          </Button> */}
        </div>
        <div className="flex flex-col gap-4 px-4">
          <div className={`items-center flex justify-between rounded-xl`}>
            <div className="flex gap-4 items-center justify-center w-full">
              <div className="flex flex-col gap-2 w-full">
                {statusTrip === EStatusTrip.IN_PROGRESS && (
                  <div className="text-primary">Đang tìm tài xế....</div>
                )}
                {(statusTrip === EStatusTrip.CANCELED ||
                  statusTrip === EStatusTrip.REJECTED) && (
                  <div className="text-red-600">Chuyến đi đã bị hủy....</div>
                )}
                <div className="flex justify-between items-center w-full">
                  <div className="flex items-center gap-4">
                    <img src="/images/logo.png" alt="" className="w-[32px]" />
                    <div className="text-[14px] font-semibold mt-2">
                      Tài xế ô tô
                    </div>
                  </div>
                  {dataServices?.totalCustomerPaid && (
                    <div className="flex flex-col gap-2 mt-2">
                      <div
                        className={`text-[16px] font-semibold text-primary ${
                          voucherValue > 0
                            ? "line-through !text-[14px] !text-black"
                            : ""
                        }`}
                      >
                        {(
                          (dataServices?.totalCustomerPaid || 0) + addPrice
                        ).toLocaleString("vi-VN")}{" "}
                        đ
                      </div>
                      {voucherValue > 0 && (
                        <div className="text-[16px] font-semibold text-green-500">
                          {(
                            (dataServices?.totalCustomerPaid || 0) +
                            addPrice -
                            voucherValue
                          ).toLocaleString("vi-VN")}{" "}
                          đ
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <Steps
                  className="custom-icon-steps"
                  progressDot={(iconDot, { index, status }) => (
                    <div className="custom-dot">
                      {index === 0 ? (
                        <svg
                          className="text-primary w-[14px]"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.49997 10.3847C9.0931 10.3847 10.3846 9.09322 10.3846 7.50009C10.3846 5.90696 9.0931 4.61548 7.49997 4.61548C5.90684 4.61548 4.61536 5.90696 4.61536 7.50009C4.61536 9.09322 5.90684 10.3847 7.49997 10.3847Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <circle
                            cx="7.5"
                            cy="7.5"
                            r="6.75"
                            stroke="currentColor"
                            stroke-width="1.5"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="text-primary w-[14px]"
                          width="16"
                          height="20"
                          viewBox="0 0 16 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.875 7.52969C14.875 12.1875 8 19.0625 8 19.0625C8 19.0625 1.125 12.1875 1.125 7.52969C1.125 3.16031 4.67781 0.625 8 0.625C11.3222 0.625 14.875 3.16031 14.875 7.52969Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <path
                            d="M8 10C9.38071 10 10.5 8.88071 10.5 7.5C10.5 6.11929 9.38071 5 8 5C6.61929 5 5.5 6.11929 5.5 7.5C5.5 8.88071 6.61929 10 8 10Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                        </svg>
                      )}
                    </div>
                  )}
                  current={4}
                  items={[
                    {
                      description: "Điểm đi",
                      title: dataPlace.from.description,
                    },
                    ...dataPlace.to
                      .filter((place) => place.show && place.placeId)
                      .map((place, index) => ({
                        description: `Điểm đến ${index + 1} - ${
                          (dataServices.distances[index] / 1000).toFixed(1) +
                          " km"
                        } - ${Math.round(
                          dataServices.durations[index] / 60
                        )} phút`,
                        title: place.description,
                      })),
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="px-4 mt-4">
          <div className="flex justify-between">
            <div
              className="w-1/2 text-center text-sm font-semibold"
              onClick={() => setOpenVoucher(true)}
            >
              Khuyến mãi
            </div>
            <div
              className="w-1/2 text-center text-sm font-semibold"
              onClick={() => setOpenNote(true)}
            >
              Ghi chú
            </div>
          </div>
          {statusTrip === EStatusTrip.IN_PROGRESS && (
            <Button
              className=" w-full mt-4"
              size="large"
              variant="solid"
              color="primary"
              onClick={() => handleCancelTrip()}
            >
              <span className="text-[16px] font-bold text-white">
                Hủy chuyến
              </span>
            </Button>
          )}

          {(statusTrip === EStatusTrip.CANCELED ||
            statusTrip === EStatusTrip.REJECTED) && (
            <Button
              className=" w-full mt-4"
              size="large"
              variant="solid"
              color="primary"
              onClick={() => {
                window.location.href = "/booking-driver";
              }}
            >
              <span className="text-[16px] font-bold text-white">
                Đặt chuyến khác
              </span>
            </Button>
          )}

          {!statusTrip && (
            <Button
              className=" w-full mt-4"
              size="large"
              variant="solid"
              color="primary"
              onClick={() => handleBooking()}
            >
              <span className="text-[16px] font-bold text-white">
                Đặt chuyến
              </span>
            </Button>
          )}
        </div>
      </div>

      <Drawer
        title={
          <div className="flex flex-col gap-4">
            <div className="flex justify-between">
              <span className="uppercase font-bold tex-[20px]"> Ghi chú</span>
              <CloseOutlined
                onClick={() => setOpenNote(false)}
                style={{ fontSize: 18, cursor: "pointer" }}
              />
            </div>
          </div>
        }
        footer={
          <Button
            variant="solid"
            color="primary"
            size="large"
            className="w-full"
            onClick={() => {
              setOpenNote(false);
            }}
          >
            <span className="text-[16px] font-semibold "> Lưu</span>
          </Button>
        }
        placement={"bottom"}
        closable={false}
        onClose={() => setOpenNote(false)}
        open={openNote}
        height={"100%"}
      >
        <Input.TextArea
          rows={4}
          placeholder="Nhập ghi chú"
          value={noteTxt}
          onChange={(e) => setNoteTxt(e.target.value)}
          allowClear
        />
      </Drawer>

      <Drawer
        title={
          <div className="flex flex-col gap-4">
            <div className="flex justify-between">
              <span className="uppercase font-bold tex-[20px]">
                {" "}
                Mã giảm giá của tôi
              </span>
              <CloseOutlined
                onClick={() => setOpenVoucher(false)}
                style={{ fontSize: 18, cursor: "pointer" }}
              />
            </div>
            <div>
              <Input.Search
                placeholder="Bạn có mã giảm giá khác"
                enterButton={<Button type="primary">Áp dụng</Button>}
                allowClear
                onChange={(e) => {
                  if (!e.target.value) {
                    setVoucherTxt("");
                    setVoucherValue(0);
                  }
                }}
                onSearch={applyVoucher}
              />
              {voucherTxt && (
                <div
                  className="mt-4"
                  dangerouslySetInnerHTML={{ __html: voucherTxt }}
                />
              )}
            </div>
          </div>
        }
        placement={"bottom"}
        closable={false}
        onClose={() => setOpenVoucher(false)}
        open={openVoucher}
        height={"100%"}
      >
        {vouchers.map((voucher) => (
          <div
            style={{
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
            className=" rounded-[14px] bg-white p-2 mb-4"
          >
            <div className="flex gap-2 w-full items-center justify-between">
              <img src="/images/logo-taxi.jpg" className="w-[60px]" alt="" />
              <div className="flex flex-col">
                <div className="font-semibold text-[16px] text-primary">
                  {" "}
                  Mã {voucher.code}
                </div>
                <div className="text-red-600 text-[14px] font-bold">
                  {voucher.title}
                </div>{" "}
                <div className="text-[14px]">
                  Áp dụng từ{" "}
                  {dayjs(voucher.startDate).format("HH:mm DD/MM/YYYY")} đến{" "}
                  {dayjs(voucher.endDate).format("HH:mm DD/MM/YYYY")}
                </div>
                <div
                  onClick={() => applyVoucherPick(voucher)}
                  className="text-blue-700 font-medium text-[14px] ml-auto"
                >
                  <span className="font-semibold">Áp dụng</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Drawer>
    </div>
  );
};

export default Map;
